import React, { useContext, useRef, useState } from "react";

// Ionic
import { IonButton, IonContent, IonSpinner, useIonToast } from "@ionic/react";

// Types
import { MemberInterface } from "../../types";
import AuthenticatedUserContextType from "../../types/AuthenticaterUserContext";

// Context
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";

// Utils

// Requests

// Components
import { useTranslation } from "react-i18next";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import ManageAccountLink from "../../components/Profile/ManageAccountLink";
import ProfileHeader from "../../components/Profile/ProfileHeader";

// Styling
import { debug } from "../../App";
import { FormComponent, FormComponentRef } from "../../components/Forms/FormComponent";
import "./Profile.scss";
import "./ProfileAdmin.scss";
const Profile = (props: any) => {
  const profileForm = useRef<FormComponentRef>(null);
  const { member } = useContext(AuthenticatedUserContext) as AuthenticatedUserContextType;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { t } = useTranslation();
  const [present] = useIonToast();

  return (
    <BasicTemplate className="profile" hideBackButton={true}>
      <IonContent>
        <div className="profile__layout">
          <div className="profile__main">
            <div className="profile__inner">
              {/* @ts-ignore */}
              <ProfileHeader member={member} />

              <div className={"wrapper ion-padding"}>
                <FormComponent
                  ref={profileForm}
                  name={"profile"}
                  includeLabels={true}
                  partialEditMode={true}
                  formData={member as object}
                  onSuccess={(member: MemberInterface, formData: any) => {
                    debug("Success", member, formData);
                    present({
                      position: "bottom",
                      color: "success",
                      duration: 3000,
                      message: t("profileUpdated"),
                    });
                    setIsSubmitting(false);
                  }}
                  onError={(err) => {
                    console.error(err);
                    present({
                      position: "bottom",
                      color: "danger",
                      duration: 3000,
                      message: t("errorUpdatingProfile"),
                    });
                    setIsSubmitting(false);
                  }}
                />

                <IonButton
                  onClick={() => {
                    setIsSubmitting(true);
                    profileForm.current?.submit();
                  }}
                  disabled={isSubmitting}
                  className={"ion-margin-top"}
                >
                  {isSubmitting && <IonSpinner name="dots" style={{ marginRight: "1em" }} />}
                  {isSubmitting ? t("submitting") : t("submit")}
                </IonButton>
              </div>

              <div className="wrapper">{member && !member.is_admin && <ManageAccountLink member={member} className="ion-padding ion-text-center" />}</div>
            </div>
          </div>
        </div>
      </IonContent>
    </BasicTemplate>
  );
};

export default Profile;
